import { useState } from "react";

import { LinkIcon } from "lucide-react";
import { Button, type ButtonProps } from "reactstrap";

import { LandingPageLinkModal } from "./LandingPageLinkModal";

interface LandingPageLinkModalButtonProps {
  campaignId: string;
  buttonProps?: ButtonProps;
}

export const LandingPageLinkModalButton = ({
  campaignId,
  buttonProps,
}: LandingPageLinkModalButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <div className="d-flex flex-column gap-2">
      <Button
        color="primary"
        outline
        size="sm"
        className="d-flex align-items-center gap-2"
        onClick={handleOpen}
        {...buttonProps}
      >
        <LinkIcon size={"1.2em"} />
        Get Link and Instructions
      </Button>
      <LandingPageLinkModal
        isOpen={isOpen}
        onClose={handleClose}
        campaignId={campaignId}
      />
    </div>
  );
};
